define([
	"csi/def/ActionFactory",
	"csi/reflection",
	"./_StateAction"
], function(ActionFactory,reflection,_StateAction) {

	return ActionFactory.declare("Endorse", _StateAction, {
		m_tag: "Endorse",

		_hasStateAccess: function(/*csi.def.Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: check access based on current state
			return revision.State == reflection.REVISION_DRAFT;
		}
	});
});